import React from 'react';
import { observer } from 'mobx-react';
import {store} from '../stores/mainStore';
import { observable } from 'mobx';
import styled from 'styled-components/macro';
import { B64Image } from './B64Image';

const SpriteImg = styled(B64Image)`
	transition: opacity 250ms;
	opacity: 0;
`

@observer
export class Sprite extends React.Component {

	@observable opacity = 1;
	@observable ready = true;

	// constructor(props){
	// 	super(props);
	// 	this.timeout = setTimeout(() => {
	// 		if(!this.ready) this.opacity = 0;
	// 	}, 100);
	// }

	// onReady = () => {
	// 	clearTimeout(this.timeout);
	// 	this.ready = true;
	// 	this.opacity = 1;
	// }

	render(){
		const p = this.props;
		var {onComplete, children, style, ...rest} = this.props;

		style = {...style} || {};
		if(p.w){
			style.width = p.w+(p.unit || 'vw');
		} else if(p.h) {
			style.height = p.h+(p.unit || 'vw');
		}

		style.opacity = this.opacity;

		return (
			<SpriteImg className={`sprite sprite-${p.sprite.split('.')[0]} ${p.className}`} {...rest} style={style} alt={p.sprite} src={`/assets/languages/${store.settings.language}/${p.sprite}`}/>
		)
	}

}
